import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './week-day-time-availability.reducer';

export const WeekDayTimeAvailabilityDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const weekDayTimeAvailabilityEntity = useAppSelector(state => state.weekDayTimeAvailability.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="weekDayTimeAvailabilityDetailsHeading">
          <Translate contentKey="activitiesApp.weekDayTimeAvailability.detail.title">WeekDayTimeAvailability</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{weekDayTimeAvailabilityEntity.id}</dd>
          <dt>
            <span id="adultCount">
              <Translate contentKey="activitiesApp.weekDayTimeAvailability.adultCount">Adult Count</Translate>
            </span>
          </dt>
          <dd>{weekDayTimeAvailabilityEntity.adultCount}</dd>
          <dt>
            <span id="childCount">
              <Translate contentKey="activitiesApp.weekDayTimeAvailability.childCount">Child Count</Translate>
            </span>
          </dt>
          <dd>{weekDayTimeAvailabilityEntity.childCount}</dd>
          <dt>
            <span id="infantCount">
              <Translate contentKey="activitiesApp.weekDayTimeAvailability.infantCount">Infant Count</Translate>
            </span>
          </dt>
          <dd>{weekDayTimeAvailabilityEntity.infantCount}</dd>
          <dt>
            <Translate contentKey="activitiesApp.weekDayTimeAvailability.weekDayTime">Week Day Time</Translate>
          </dt>
          <dd>{weekDayTimeAvailabilityEntity.weekDayTime ? weekDayTimeAvailabilityEntity.weekDayTime.weekDay : ''}</dd>
        </dl>
        <Button tag={Link} to="/week-day-time-availability" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/week-day-time-availability/${weekDayTimeAvailabilityEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default WeekDayTimeAvailabilityDetail;
